import { registerSelectors } from '@westondev/tableturn-core';

export const {
  selectDrawers,
} = registerSelectors;
